import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { JsonHttpService } from 'src/app/shared/http/json-http.service';
import * as internal from 'stream';
import { IdentityApplication } from '../models/identity-application';
import { IdentityScope } from '../models/identity-scope';
import { IdentityTokenView } from '../models/identity-token-view';

@Injectable({
  providedIn: 'root'
})
export class IdentityService {

  constructor(
    private http: JsonHttpService) {
  }

  getApplications(): Promise<IdentityApplication[]> {
    return this.http.get('/api/identity/application').pipe(
      tap(response => {
        response.map(application => {
          if (!Array.isArray(application.RedirectUris)) {
            application.RedirectUris = [];
          }
          application.RedirectUri = application.RedirectUris.length > 0 ? application.RedirectUris[0] : '';

          if (!Array.isArray(application.PostLogoutRedirectUris)) {
            application.PostLogoutRedirectUris = [];
          }
          application.PostLogoutRedirectUri = application.PostLogoutRedirectUris.length > 0 ? application.PostLogoutRedirectUris[0] : '';

          return application;
        });
      })
    ).toPromise();
  }

  createApplication(application: IdentityApplication, useGenericErrorHandling: boolean = true): Promise<IdentityApplication> {
    return this.http.post('/api/identity/application', application, null, useGenericErrorHandling).toPromise();
  }

  updateApplication(application: IdentityApplication, useGenericErrorHandling: boolean = true): Promise<IdentityApplication> {
    return this.http.put('/api/identity/application', application, null, useGenericErrorHandling).toPromise();
  }

  deleteApplication(applicationId: string, useGenericErrorHandling: boolean = true): Promise<void> {
    return this.http.delete(`/api/identity/application/${applicationId}`, null, useGenericErrorHandling).toPromise();
  }

  getScopes(): Promise<IdentityScope[]> {
    return this.http.get('/api/identity/scope').toPromise();
    }

  getTokenViews(count: number): Promise<IdentityTokenView[]> {
    return this.http.get(`/api/identity/tokenview/${count}`).toPromise();
}
}
